export default {
  title: "Сатуу пункттары",
  name: "Сатуу пунктунун аты",
  namingNoSpecified: "Аты көрсөтүлгөн эмес",
  tradingPoint: "Сатуу пункту",
  addressNoSpecified: "Дарек көрсөтүлгөн эмес",
  info: "Сатуу пункту тууралуу маалымат",
  add: {
    title: "Сатуу пунктун түзүү",
    noOperations: "Бир дагы операция жасалган жок",
  },
  historyOperation: "Чектердин тарыхы",
  employee: "Кызматкер",
  customer: "Кардар",
  source: "Булак",
  typeOperation: "Операциянын түрү",
  typeActivity: "Ишмердүүлүк түрү",
  writing: "Списания",
  accrual: "Талап кылуу",
  sumBuy: "Сатып алуу суммасы",
  sumWrite: "Списания суммасы",
  toPay: "Төлөнүүчү сумма",
  totalCashback: "Жалпы сыйлык",
  salePopup: "Жеңилдик",
  types: {
    balance_up: "Баланс толтуруу",
    balance_down: "Акча списаниясы",
    tsp_approve: "Чек боюнча эсептешүү",
    balance_refill: "Баланс толтуруу",
    tariff_change: "Тариф сатып алуу",
    cashback_approve: "Кардардын сапары",
    cashback_charge: "Чек. Балл списаниясы",
    certificate_charge: "Талап кылуу. Сыйлык картасын колдонуу",
    certificate_debt: "Списания. Сыйлык картасын берүү",
    certificate_refund: "Сыйлык картасын кайтаруу",
    rc_withdraw: "Чек. Балл кабыл алуу",
    tsp_commission_fee: "Чек. Комиссия",
    tsp_commission_revert:
      "1-апрелден эсептелгенге чейин туура эмес списания суммасынын кайра эсептелиши",
    tsp_commission_correct:
      "Кабыл алынган баллдардын 1% өлчөмүндө эсептешүүнү тууралоо",
    manual_commission_approve: "Чек. Комиссия боюнча эсептешүү",
    manual_withdraw: "Акчаны чыгаруу",
    cashback_decline: "Чекти жокко чыгаруу",
    rc_processing_receipts: "Касса аппаратынын чеги",
    cashback_approve_decline: "Кардардын сапары үчүн төлөмдү жокко чыгаруу",
    partner_manual_withdraw: "Акчаны списаниялоо",
    inner_cashback_charge: "Чек. Сыйлык списаниясы",
    inner_cashback_approve: "Чек боюнча эсептешүү",
    tsp_approve_payment: "Чек. Акчаны списаниялоо",
    rc_withdraw_approve: "Чек. Балл менен төлөм",
    withdraw_payment: "Чек. Акчаны списаниялоо",
    prodazha_top_mesta: "RCPAYде топ орун сатып алуу",
    reserving_funds_withdrawal: "Төлөөгө резервделди",
    refund_reserved_funds_withdrawal: "Резервден кайтаруу",
    withdraw_reserved_funds: "Акчаны чыгаруу",
  },
  organizations: "Юр. жак",
  moderationModalTitle: "Модерациядан билдирүү",
  clients: "кардарга: ",
  other: "комиссия: ",
  total: "Жалпы: ",
  draft: "Каралама",
  itsAppearAfterCreateShop: "Сатуу пунктун түзгөндөн кийин пайда болот",
  inRCPay: {
    published: "RC PAYде жарыяланган",
    unpublished: "RC PAYде жарыяланбаган",
  },
  promotion: "Илгерилетүү",
  openInRCPay: "RC PAYде ачуу",
  couldntSendShopToModeration: "Сатуу пунктун сактай алган жок",
  shopChangesSuccessSaved: "Сатуу пункту маалыматтары ийгиликтүү сакталды",
  forLayoultyCreateEmployee:
    "Сыйлуулук программасы менен иштөө үчүн «Кассирлер» бөлүмүндө кассир түзүп, аны ушул сатуу пунктуна байлоо керек.",
  changesSendedToModeration: "Сатуу пункту маалыматтары модерацияга жөнөтүлдү",
  someChangesNeedModeration: "Кээ бир өзгөртүүлөр модерацияны талап кылат",
  changesUpdateAfterModeration:
    "RC PAYде көрсөтүлгөн заведениенин карточкасында өзгөртүүлөр модерациядан жана текшерүүдөн кийин жаңыртылат.",
  connectedPaymentMethod: "Сатуу пунктуна төлөм ыкмалары туташтырылган.",
  ifNeedDeleteConnectWithUs:
    "Эгер өчүрүү керек болсо, техникалык колдоого кайрылыңыз",
  ifNeedDeleteConnectWithUsSuccess: "Электрондук почта клипбордга көчүрүлдү",
  someFieldsUncorrect: "Кээ бир талаалар туура эмес толтурулган",
  backToEditingToFixIt:
    "Ону түздөө үчүн кайра редакцияга кайтыңыз. Эгер сактап калбай чыгууну кааласаңыз, «Пропустить» баскычын басыңыз.",
  wannaQuit: "Чыгууну каалайсызбы?",
  allNotSavedChangesWillRemove:
    "Сакталбаган бардык өзгөртүүлөр жок болот. Сактоо үчүн артка кайтыңыз.",
  cancelCreationPointModal: {
    title: "Сатуу пунктун түзүүнү токтотуу?",
    subtitle:
      "Киргизилген маалыматтар сакталбайт. Редакцияга кайтуу үчүн «Артка» басыңыз.",
  },
  moderationModal: {
    title: "Сатуу пункту ийгиликтүү түзүлүп, модерацияга жөнөтүлдү",
    subtitle:
      "Сыйлуулук программасы менен иштөө үчүн «Кассирлер» бөлүмүндө кассир түзүп, аны ушул сатуу пунктуна байлоо керек.",
  },
  deletePromotionModal: {
    title:
      "Иштеп жаткан илгерилетүү кызматы менен сатуу пунктун чын эле өчүргүңүз келеби?",
    subtitle:
      "Өчүрүүдөн кийин илгерилетүү кызматтары токтойт. Илгерилетүүгө төлөнгөн акчалар кайтарылбайт. Сатуу пунктунун маалыматтарын калыбына келтирүү мүмкүн эмес.",
  },
  deleteModal: {
    title: "Сатуу пунктун чын эле өчүргүңүз келеби?",
    subtitle: "Өчүрүүдөн кийин маалыматтарды калыбына келтирүү мүмкүн эмес.",
    shopDeleted: "Сатуу пункту өчүрүлдү",
  },
  lessTariffModal: {
    title: "Сиз тариф боюнча максималдуу сатуу пунктун түздүңүз",
    subtitle:
      "Көбүрөөк сатуу пункттарын түзүү үчүн башка тарифти сатып алуу керек.",
  },
  validation: {
    specifyMailOrRemoveField:
      "Электрондук почта дарегин көрсөтүңүз же талааны өчүрүңүз",
    specifyLinkAddressOrRemove: "Ссылка дарегин көрсөтүңүз же талааны өчүрүңүз",
    couldntSendShopToModeration: "Сатуу пунктун модерацияга жөнөтө алган жок",
    someImagesCouldntProcess:
      "Кээ бир сүрөттөрдү иштеп чыгуу мүмкүн болбоду. Башка сүрөттөрдү жүктөп көрүңүз",
  },
  creationTab: {
    main: "Негизги",
    loyalty: "Сыйлуулук программасы",
    addressAndOpeningHours: "Дарек жана иштөө убактысы",
    contacts: "Байланыштар",
    foto: "Сүрөт",
  },
  stepFromTo: "Кадам {from} из {total}",
  createShopAndContinue: "Сатуу пунктун түзүп улантуу",
  createShop: "Соода жайын түзүү",
  message: {
    dataSavedToDraft: "Сатуу пунктунун маалыматтары черновикке сакталды",
    dataSavedAndSendToModeration: "Өзгөртүүлөр сакталып, модерацияга жөнөтүлдү",
    dataSuccessSaved: "Өзгөртүүлөр ийгиликтүү сакталды",
    fillCorrectSpecifiedFields: "Көрсөтүлгөн талааларды туура толтуруңуз",
    fillCorrectAllRequiredFields:
      "Бардык милдеттүү талааларды туура толтуруңуз",
  },
  describeYourCompany:
    "Компанияңызды толук сүрөттөп бериңиз. Хэштег (#) жана смайликтерди колдонбоңуз. Дарек, байланыштар жана иштөө убактысы ар башка бөлүмдөрдө көрсөтүлсүн.",
  willDisplayToUserInRCPay: "RC PAYде колдонуучуларга көрсөтүлөт",
  activityTooltip:
    "Тандалган категориялар боюнча фильтр колдонулганда, сиздин жай RC PAY издөө натыйжаларында көрсөтүлөт.",
  afterModerationEntityEditingDisable:
    "Модерациядан кийин юр. жакты түзөтүү мүмкүн эмес. Өзгөртүү үчүн техникалык колдоого кайрылыңыз.",
  description: "Сатуу пункту жөнүндө маалымат",
  charsLimit: {
    min: "Минимум символдор - {minChars}",
    max: "Максимум символдор - {maxChars}",
  },
  features: "Өзгөчөлүктөр",
  selectedFeaturesWillDisplayInCard:
    "Тандалган опциялар RC PAYде заведениенин карточкасында тегдер катары көрсөтүлөт",
  catalogTitles: "RC PAYде товар/кызмат блогу аты",
  catalogTitlesTooltip:
    "Сатуу пунктунун товар/кызмат тизмесинин жалпы аталышы. RC PAYде заведениенин баракчасында гана колдонулат.",
  totalPercentReward: "Жалпы сыйлык пайызы",
  totalRewardLabel: "Жалпы сыйлык %",
  totalPercentRewardValue: "Сыйлыктын жалпы пайызы (4дөн 25ке чейин).",
  rewardWillPayToClients:
    "Кардарларга сыйлык бөлүштүрүү сценарийине ылайык төлөнөт.",
  checkRewardDistribution: "Сыйлык бөлүштүрүү сценарийлерин караңыз",
  activeWait: "Сыйлыкты эсептөө кечигүүсү",
  activeWaitTooltip:
    "Кардар сатып алган күндөн тартып сыйлык эсептелгенге чейин күндөр саны (0–14)",
  clientDiscount: "RC PAY кардарларына жеңилдик",
  clientDiscountTooltip:
    "Кардарлар программасынын RC GROUP кардарларына берилүүчү жеңилдик пайызы (0–99) сатып алуу учурунда",
  shopPaylable: "Сатуу пункту RC баллдары менен төлөөнү кабыл алат",
  shopPaylableDescription:
    "RC PAYде катталган кардарлар сатып алуунун 99,9% чейин балл менен төлөй алышат",
  enteredDataNotNeedModeration:
    "Киргизилген маалыматтар модерацияны талап кылбайт жана сатуу пунктун түзгөндө же өзгөртүүлөр сакталганда (эгер юр. жак ырасталса) дароо колдонулат.",
  address: "Дарек",
  ifNoYourShopSelectNear:
    "Эгер картада заведениенин дареги жок болсо, жакынкы даректи тандап, техникалык колдоого кайрылыңыз",
  startEnteringAddress: "Даректи киргизип, тизмеден тандаңыз",
  addressComment: "Дарекке комментарий",
  specifyWayToGetYouShop:
    "Заведениеге жетүү жолун, алдын ала чалуу керек болсо белгилеңиз же башка кошумча маалыматты көрсөтүңүз (милдеттүү эмес)",
  period: {
    workdays: "Иш күндөрү ПН-ПТ",
    weekend: "Дем алыш күндөрү СБ-ВС",
    allDay: "Ар күн ПН-ВС",
    aroundClock: "Тунук күнү 24/7",
  },
  catalog: "Каталог",
  intervals: "Интервалдар",
  weekdays: "Апта күндөрү",
  selectedAllDays: "Бардык апта күндөрү тандалды",
  workHoursInOtherDays: "Башка күндөрдүн иштөө убактысы",
  workDays: "Иш күндөрү",
  workDaysMobileSubtitle:
    "Бир график боюнча иштеген күндөрдү же интервалдарды тандаңыз (бардык тандалган күндөр үчүн сааттар бирдей).",
  workDaysTooltips: [
    "Бир график боюнча иштеген күндөрдү же интервалдарды тандаңыз (мисалы, ПН-ПТ 10:00–20:00).",
    "Андан кийин «Башка күндөрдүн иштөө сааты» баскычын басып, сааттары башка күндөрдү тандаңыз (мисалы, СБ 12:00–16:00).",
  ],
  specifyWorkTimeInSelectedDays:
    "Тандалган күндөрдүн иштөө сааттарын көрсөтүңүз",
  publicTradingPoint: "Сатуу пунктун rcpay.ru сайтында жарыялоо",
  publicTTDescription: [
    "Сатуу пункту rcpay.ru сайтында жана RC PAY мобилдик тиркемесинде ошол шаарда көрсөтүлөт.",
    "RC PAYде заведениени жайгаштыруу модератор тарабынан ырасталганда гана ишке ашат. Жайгаштырууну өчүрүү үчүн ушул опцияны ажыратып коюңуз, модерация талап кылынбайт.",
  ],
  workOnline: "Сатуу пункту онлайн иштейт",
  workOnlineDescription: [
    "Көрсөтүлгөн кызматтар/товарлар гана онлайн/жеткирүү аркылуу сатылат.",
    "«Дарек» талаасында шаардагы сатуу пунктунун болжолдуу дарегин көрсөтүңүз – RC PAYде заведениенин карточкасында көрсөтүлбөйт, анын ордуна «Онлайн» сөзү көрсөтүлөт.",
  ],
  time: "Иш сааттары",
  specifyPhoneNumberOrRemove: "Телефон номерин көрсөтүңүз же талааны өчүрүңүз",
  specifyMailOrRemove: "Почтаны көрсөтүңүз же талааны өчүрүңүз",
  onlineService: "Онлайн жазылуу сервиси",
  specifyLinkIfUseOtherServicesForOnline:
    "Кардарларды онлайн жаздыруу үчүн даяр сервистерди колдонсоңуз, шилтемени бул жерде көрсөтүңүз",
  linkAddress: "Ссылка дареги",
  addSiteOrSocialMedia: "Сайтка же соц. тармакка шилтемелерди кошуу",
  linkName: "Ссылка аты",
  linkNameTooltips: [
    "RC PAYде шилтемени кантип көрсөтүүнү каалай турганыңызды көрсөтүңүз. Мисалы, «Сатып алуу» же «Брондоо».",
    "Эгер эч нерсе көрсөтүлбөсө, шилтеме дареги көрсөтүлөт.",
  ],
  pointPhotos: "Сатуу пунктунун сүрөттөрү",
  photosRequirements:
    "Сүрөттөр эң мыкты сапатта, суунун белгиси, жазуулары жана коллажсыз болушу керек",
  logo: "Логотип",
  photoRecomendation: "Сүрөт боюнча сунуштар",
  logoRecomendations: [
    "JPEG, JPG, PNG форматы 10 Мб чейин, пропорциясы 1:1",
    "Логотип, тематикалык сүрөт, заведениенин аты же фирмалык белги",
    "Сапаттуу сүрөт, дарек, телефон жана кошумча маалыматтарды камтыбайт",
  ],
  uploadLogo: "Логотипти жүктөө",
  noClient: "Кардар жок",
  giftCard: "Сыйлык картасы",
  totalCashbackHints: [
    "Чекте жалпы сыйлык пайызы көрсөтүлгөн, бирок чектеги сумма фактически списанияланган баллга туура келбеши мүмкүн.",
    "Бул сатып алган кардардын түрүнө (ички же тышкы) жана тарифке байланыштуу.",
  ],
  previewInRCPay: "RC PAYде алдын ала карап көрүү",
  searchByTable: "Таблица боюнча издөө",
  noCheckData: "Чектер боюнча маалыматтар жок",

  babySafeSeat: "Балалар креслосу",
  parking: "Парковка",
  wifi: "WiFi",
  aroundTheClock: "Түнү-күнү",
  "16+": "16+",
  noSmoking: "Тамеки чегүүгө тыюу салынат",
  habitation: "Жашоо",
  nutrition: "Тамактануу",
  transfer: "Трансфер",
  excursion: "Экскурсиялар",
  cardPay: "Карта менен төлөө",
  foodTakeAway: "Үйгө алып кетүүчү тамак",
  conditioner: "Кондиционер",
  delivery: "Жеткирүү",
  animalsAllow: "Үй жаныбарлары менен келүүгө болот",
  dogAllow: "Ити менен келүүгө болот (35 смден төмөн)",
  childrenRoom: "Балалар бөлмөсү",

  assortment: "Ассортимент",
  showcase: "Витрина",
  menu: "Меню",
  portfolio: "Портфолио",
  price: "Прайс",
  products: "Товарлар",
  productsAndServices: "Товарлар жана кызматтар",
  services: "Кызматтар",

  // food
  food: "Тамак-аш",
  cafe: "Кафе",
  restaurants: "Ресторандар",
  barsClubs: "Барлар жана клубдар",
  fastfood: "Тез тамак (фастфуд)",
  coffeeShop: "Кофейнялар",
  canteens: "Тамакканалар",
  foodDelivery: "Тамак жеткирүү жана түшкү тамактар",
  vegetables: "Жемиштер, жашылча жана зелень",
  pizzeria: "Пиццерия",
  goods: "Азык-түлүк",
  specials: "Специалдык",
  sushiBar: "Суши-бар",
  bakeryProducts: "Нан жана таттуулар",
  // shopping
  shopping: "Шопинг",
  clothes: "Кийим",
  shoes: "Бут кийим",
  accessories: "Аксессуарлар",
  flowers: "Гүлдөр",
  jewerly: "Зер буюмдар",
  booksAndCancellery: "Китептер жана кеңсе товарлары",
  zooItems: "Жаныбарлар үчүн товарлар",
  // health and beauty
  beautyAndHealth: "Сулуулук жана ден соолук",
  care: "Кам көрүү",
  spa: "Спа",
  medicine: "Медицина",
  pharmacy: "Дарыкана",
  cosmeticAndParfume: "Косметика жана парфюмерия",
  cosmetology: "Косметология",
  nailStudio: "Тырмак студиясы",
  barbershop: "Чач тарач",
  beautyStudio: "Сулуулук салону",
  stylistsAndMakeupers: "Визажисттер, стилисттер",
  // electronic
  technique: "Техника",
  electronic: "Электроника",
  homeAppliances: "Үй техникасы",
  officeEquipment: "Офис техникасы",
  communicationSalon: "Байланыш салону",
  photoTech: "Фото техника",
  // house
  house: "Үй",
  householdGoods: "Тиричилик товарлары",
  renovation: "Ондоо",
  furniture: "Жыгач буюмдар (мебель)",
  garden: "Бакча жана огород",
  decorAndInterior: "Декор жана интерьер",
  dishes: "Тамак идиштер",
  plumbing: "Сантехника",
  buildingMaterials: "Курулуш материалдары",
  homeTextile: "Үй текстили",
  // for children
  forChildren: "Балдар үчүн",
  childClothesAndShoes: "Балдар кийими жана бут кийими",
  childFood: "Балдар тамагы",
  forMothers: "Энелер үчүн",
  toysAndGames: "Оюнчуктар жана оюндар",
  childSections: "Балдар секциялары",
  // entertaiments
  entertaiments: "Эс алуу жана көңүл ачуулар",
  parks: "Парктар",
  cinema: "Кинотеатрлар",
  spaces: "Мейкиндиктер",
  entertainmentCenter: "Көңүл ачуучу борбор",
  // sport
  sport: "Спорт",
  clothesAndShoes: "Кийим жана бут кийим",
  turizm: "Туризм",
  sportGym: "Спорт залдар",
  swimmingPool: "Бассейн",
  specClothes: "Атайын кийимдер",
  sportClotheAndShoes: "Спорттук кийим жана бут кийим",
  sportNutrition: "Спорттук азыктар",
  sportSections: "Спорт секциялары",
  sportItems: "Спорт товарлары",
  danceStudio: "Бий студиялары",
  // hobby
  hobby: "Хобби",
  specShops: "Адистешкен дүкөндөр",
  studios: "Студиялар",
  handicraftsAndCreativeProducts: "Кол өнөрчүлүк жана чыгармачылык товарлар",
  // services
  computerHelping: "Компьютердик жардам",
  photoAndVideo: "Фото жана видео",
  giftsAndHolidays: "Белектер жана майрамдар",
  leisure: "Эс алуу",
  repairAndInterior: "Ондоо жана интерьер",
  rentAndRental: "Ижара жана прокат",
  traveling: "Саякат",
  studying: "Окуу",
  atelier: "Ателье",
  autoServices: "Авто кызматтар жана сервистер",
  householdServices: "Тиричилик кызматтары",
  cargoTransporation: "Жүк ташуу",
  legalServices: "Юридикалык кызматтар",
  cleaning: "Тазалоо (клининг)",
  consultations: "Кеңеш берүү",
  supermarkets: "Супермаркеттер",
  buildingAndReparir: "Курулуш жана оңдоо",
  // other
  others: "Башка",
  gasStations: "Май куюучу жайлар (АЗС)",
  halal: "Халяль",
  // rent and booking
  rentAndBooking: "Ижара жана брондоо",
  apartments: "Апартаменттер",
  houseRental: "Турак жай ижарасы",
  boutiqueHotel: "Бутик-отель",
  guesthouse: "Гестхаус",
  resortHotel: "Курорттук отель",
  motel: "Мотель",
  hotels: "Отелдер",
  sanatorium: "Санаторий",
  hostel: "Хостел",
  // tourism
  tourismOfHakasia: "Хакасиядагы туризм",
  excursionsOfHakasia: "Хакасиядагы экскурсиялар",
  nutritionOfHakasia: "Хакасиядагы тамак-аш",
  trasportOfHakasia: "Хакасиядагы транспорт",
};
